import React, { memo } from "react";
import { AppColors } from "common/src/types";
import * as MuiIcons from "@mui/icons-material";
import { useThemeApp } from "components/Theme/theme";

export type IconType = "material";

export type MaterialIconName = keyof typeof MuiIcons;

export interface ThemedIconProps {
    size?: number;
    type?: IconType;
    name: MaterialIconName;
    color?: keyof AppColors;
    style?: React.CSSProperties;
    animation?: "fade" | "rotate" | "none";
}

const ThemedIconComponent = ({
    name,
    size = 24,
    color = "text",
}: ThemedIconProps) => {
    const { colors } = useThemeApp();

    const IconComponent = MuiIcons[name];

    if (!IconComponent) {
        console.warn(`Ícone "${name}" não encontrado`);
        return null;
    }

    return (
        <IconComponent
            sx={{
                fontSize: size,
                color: colors[color],
            }}
        />
    );
};

export const ThemedIcon = memo(ThemedIconComponent);